import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { agodaIcons, defaultIcons } from '@ads/assets';
import { getAssetDataFromMetadata } from '../../VisualAssets/utility/getAssetDataFromMetadata/getAssetDataFromMetadata.js';
import { getAssetDataFromTheme } from '../../VisualAssets/utility/getAssetDataFromTheme/getAssetDataFromTheme.js';

var getDataFromTheme = function getDataFromTheme(id, context) {
  var storage = {
    default: defaultIcons,
    agoda: agodaIcons
  };
  return getAssetDataFromTheme(id, storage, context.theme);
};
var getDataFromExperiment = function getDataFromExperiment(experimentContainer, context) {
  var _data2;
  var data;
  if (context.experiments.iconsMigrationToV3) {
    var _data;
    (_data = data) !== null && _data !== void 0 ? _data : data = experimentContainer.v3;
  }
  return (_data2 = data) !== null && _data2 !== void 0 ? _data2 : experimentContainer.default;
};
var getDataFromMetadata = function getDataFromMetadata(metadataContainer, context) {
  return getAssetDataFromMetadata(metadataContainer, function (data) {
    return data.symbol;
  }, context);
};

/**
 * This method returns the hash of the icon based on the theme and id
 * @param id IconId
 * @param context RequestAssetContext
 * @returns AssetHashResult
 */
var getHash = function getHash(id, context) {
  var experimentContainer = getDataFromTheme(id, context);
  if (experimentContainer === undefined) {
    // This should not happen according to our type system but may still happen if consumers provide icon ids by
    // casting them from string. We support them to some level by showing an error icon in that case
    return {
      hash: '',
      flip: false
    };
  }
  var metadataContainer = getDataFromExperiment(experimentContainer, context);
  return getDataFromMetadata(metadataContainer, context);
};

/**
 * This method returns the icon container
 * @returns HTMLDivElement
 */
var getIconContainer = function getIconContainer(window) {
  var container = window.document.getElementById('drone-icon-container');
  if (!container) {
    container = window.document.createElement('div');
    container.id = 'drone-icon-container';
    container.style.display = 'none';
    window.document.body.appendChild(container);
  }
  return container;
};

/**
 * This method appends the icon if it does not exist
 * @param svg string
 */
var appendIconInIconContainer = function appendIconInIconContainer(svg, windowObject) {
  var targetWindow = windowObject !== null && windowObject !== void 0 ? windowObject : window;
  var container = getIconContainer(targetWindow);
  container.appendChild(targetWindow.document.createRange().createContextualFragment(svg));
};

/**
 * This method requests a local icon
 * @param iconContent string
 * @returns Promise<string>
 */
var requestLocalIcon = function requestLocalIcon(iconContent) {
  return (
    // IE11 does not support Promise.resolve() but it shouldn't be in our browser list to begin with
    // eslint-disable-next-line compat/compat
    Promise.resolve("<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">".concat(iconContent, "</svg>"))
  );
};

/**
 * This method requests an icon from the CDN and returns the SVG string
 * @param hash string
 * @param iconConfig AssetEnvironment
 * @param fetchAPI typeof fetch
 * @returns Promise<string>
 */
var requestCdnIconWithHash = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(hash, iconConfig, fetchAPI) {
    var fileName, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fileName = "".concat(hash, ".svg");
          _context.next = 3;
          return fetchAPI(iconConfig.cdnUrl + fileName, {
            cache: 'force-cache'
          });
        case 3:
          response = _context.sent;
          return _context.abrupt("return", response.text());
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function requestCdnIconWithHash(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * This method requests a local icon or a CDN icon based on the hash existence in the localIcons
 * @param hash string
 * @param iconConfig AssetEnvironment
 * @param localIcons IconContext
 * @param fetchAPI
 * @returns Promise<string>
 */
var requestLocalOrCdnIconWithHash = function requestLocalOrCdnIconWithHash(hash, iconConfig, localIcons, fetchAPI) {
  var localIcon = localIcons === null || localIcons === void 0 ? void 0 : localIcons[hash];
  return localIcon ? requestLocalIcon(localIcon) : requestCdnIconWithHash(hash, iconConfig, fetchAPI);
};

/**
 * This method requests an icon based on the hash if it is not already requested
 * @param iconConfig AssetEnvironment
 * @param hash string
 * @param localIcons IconContext
 * @param fetchAPI
 * @param windowObject Window
 * @returns void
 */
var requestIconWithHash = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(iconConfig, hash, localIcons, fetchAPI, windowObject) {
    var _targetWindow$drone;
    var targetWindow, _targetWindow$drone2, _targetWindow$drone2$, _targetWindow$drone3, request, svg, _targetWindow$drone4, _targetWindow$drone4$, _targetWindow$drone5;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          targetWindow = windowObject !== null && windowObject !== void 0 ? windowObject : window;
          if (fetchAPI) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          if (hash) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return");
        case 5:
          if (!((_targetWindow$drone = targetWindow.drone) !== null && _targetWindow$drone !== void 0 && (_targetWindow$drone = _targetWindow$drone.requestedHashCache) !== null && _targetWindow$drone !== void 0 && _targetWindow$drone[hash])) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return");
        case 7:
          _context2.prev = 7;
          ((_targetWindow$drone2$ = (_targetWindow$drone2 = (_targetWindow$drone3 = targetWindow.drone) !== null && _targetWindow$drone3 !== void 0 ? _targetWindow$drone3 : targetWindow.drone = {}).requestedHashCache) !== null && _targetWindow$drone2$ !== void 0 ? _targetWindow$drone2$ : _targetWindow$drone2.requestedHashCache = {})[hash] = true;
          targetWindow.drone.requestedHashCache[hash] = true;
          request = requestLocalOrCdnIconWithHash(hash, iconConfig, localIcons, fetchAPI);
          _context2.next = 13;
          return request;
        case 13:
          svg = _context2.sent;
          appendIconInIconContainer(svg, windowObject);
          _context2.next = 20;
          break;
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](7);
          ((_targetWindow$drone4$ = (_targetWindow$drone4 = (_targetWindow$drone5 = targetWindow.drone) !== null && _targetWindow$drone5 !== void 0 ? _targetWindow$drone5 : targetWindow.drone = {}).requestedHashCache) !== null && _targetWindow$drone4$ !== void 0 ? _targetWindow$drone4$ : _targetWindow$drone4.requestedHashCache = {})[hash] = false;
          // swallow
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[7, 17]]);
  }));
  return function requestIconWithHash(_x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Request an icon to be loaded
 * @param iconConfig iconConfig icon context configuration
 * @param iconId icon ID to request
 * @param context
 * @deprecated Use <a href="https://full-stack.pages.agodadev.io/design-system/drone-js/master/?path=/docs/foundation-setup--docs#pre-bundled-icons" > pre bundled icons </a>
 */
var requestIcon = function requestIcon(iconConfig, iconId, context) {
  var _getHash = getHash(iconId, context),
    hash = _getHash.hash;
  return requestIconWithHash(iconConfig, hash);
};

export { appendIconInIconContainer, getHash, getIconContainer, requestIcon, requestIconWithHash };
//# sourceMappingURL=Icon.helper.js.map
